import "./footer.css";
const Footer = () => {
  return<div className="h-12 w-screen footer text-white text-lg flex justify-evenly items-center" >
    <div>@2023 Featherpad Editor. All rights reserved</div>
    <div>Made By: Abhinay Singh, Ankul Raj & Nikhil Pandey</div>
  </div>
};
export default Footer;
